// composables/useNotificationsSocket.js
// WebSocket connector: ping->pong keepalive, chat_message dispatch, backoff reconnect.
export function useNotificationsSocket() {
  let ws = null
  let retry = 0
  let stopped = false
  let opts = null

  const open = () => {
    if (stopped || !opts) return
    const { wsUrl, apiKey, deviceToken } = opts
    ws = new WebSocket(
      `${wsUrl}/?apikey=${encodeURIComponent(apiKey)}&deviceToken=${encodeURIComponent(deviceToken)}&platform=web`
    )

    ws.onopen = () => { retry = 0 }

    ws.onmessage = (e) => {
      let d
      try { d = JSON.parse(e.data) } catch { return }
      if (d.type === 'ping') {
        ws?.send(JSON.stringify({ type: 'pong' }))
        console.log('pong')
        return
      }
      if (d.type === 'chat_message') opts.onChatMessage(d.message)
    }

    ws.onclose = () => {
      if (!stopped) {
        const delay = Math.min(30000, 1000 * 2 ** retry++)
        setTimeout(open, delay)
      }
    }

    ws.onerror = () => ws?.close()
  }

  // connect({ wsUrl, apiKey, deviceToken, onChatMessage })
  const connect = (options) => {
    opts = options
    stopped = false
    retry = 0
    open()
  }

  const close = () => {
    stopped = true
    ws?.close()
    ws = null
  }

  return { connect, close }
}
